module.exports = __webpack_public_path__ + "img/pencil-icon.c6196d69.svg";